/**
 * Generato automaticamente.
 * OpenAPI
 */

export type EnumTipoOnereDTOTipoVincolo =
  (typeof EnumTipoOnereDTOTipoVincolo)[keyof typeof EnumTipoOnereDTOTipoVincolo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTipoOnereDTOTipoVincolo = {
  FACOLTATIVO: 'FACOLTATIVO',
  OBBLIGATORIO: 'OBBLIGATORIO',
  DA_PAGARE_DOPO_INVIO: 'DA_PAGARE_DOPO_INVIO',
} as const;
